import { useEffect, useRef, useState } from "react";
import "../../assets/css/product.scss";

import closeSvg from "../../assets/images/icons/close.svg";
import arrowBackSvg from "../../assets/images/icons/arrow_back.svg";
import arrowUpSvg from "../../assets/images/icons/arrow_up.svg";
import arrowDownSvg from "../../assets/images/icons/arrow_down.svg";

function ProductDonateModal({
  isOpen,
  onBack,
  onClose,
  phoneNumber = "",
  paymentSelect = "subscription",
  onSuccess,
}) {
  const [name, setName] = useState("");
  const [selectIsOpen, setSelectIsOpen] = useState(false);
  const [selected, setSelected] = useState("");
  const [countValue, setCountValue] = useState("");
  const [totalPrice, setTotalPrice] = useState("");
  const [cardNumbers, setCardNumbers] = useState(["", "", "", ""]);
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [paymentType, setPaymentType] = useState(null);
  const [cardPassword, setCardPassword] = useState("");
  const [birth, setBirth] = useState("");
  const dropdownRef = useRef(null);
  const inputRefs = [useRef(null), useRef(null), useRef(null), useRef(null)];
  const monthRef = useRef(null);
  const yearRef = useRef(null);

  const options = [
    "30일 구독권 / 10,000원",
    // "90일 구독권 / 30,000원",
    // "1년 구독권 / 108,000원",
  ];

  const nameChange = (e) => {
    setName(e.target.value);
  };

  const handleSelect = (value) => {
    setSelected(value);
    setSelectIsOpen(false);

    handleTotalPrice();
  };

  const handleTotalPrice = () => {
    if (selected && countValue && countValue !== "0") {
      const price = selected.split("/")[1].replace(/[^0-9]/g, "");
      setTotalPrice(parseInt(price) * parseInt(countValue));
    } else {
      setTotalPrice("");
    }
  };

  const validate = () => {
    if (!name || name.trim() === "") {
      alert("기부자 명을 입력해주세요.");
      return false;
    }
    if (!phoneNumber || phoneNumber.trim() === "") {
      alert("휴대폰 번호가 없습니다. 휴대폰 인증을 진행 해주세요.");
      return false;
    }

    if (paymentSelect === "subscription") {
      if (
        cardNumbers.every((num) => num.length === 4) === false ||
        (month.length === 2 &&
          year.length === 2 &&
          parseInt(month) >= 0 &&
          parseInt(month) <= 12) === false
      ) {
        alert("신용카드 정보를 입력해주세요.");
        return false;
      }
      if (!cardPassword || cardPassword.trim() === "") {
        alert("신용카드 비밀번호(앞2자리)를 입력해주세요.");
        return false;
      }
      if (!birth || birth.trim() === "") {
        alert("카드 소유주 생년월일을 입력해주세요.");
        return false;
      }
      if (!selectedDate || selectedDate.trim() === "") {
        alert("결제일을 선택해주세요.");
        return false;
      }
    } else {
      if (!paymentType || paymentType.trim() === "") {
        alert("결제수단을 선택해주세요.");
        return false;
      }
    }
    if (!selected || selected.trim() === "") {
      alert("상품 금액을 선택해주세요.");
      return false;
    }
    if (!countValue || countValue.trim() === "" || countValue === "0") {
      alert("상품 갯수를 입력해주세요.");
      return false;
    }
    if (parseInt(countValue) < 5) {
      alert("상품 갯수는 5개 이상 선택해주세요.");
      return false;
    }
    return true;
  };

  const reset = () => {
    setName("");
    setSelected("");
    setCountValue("");
    setTotalPrice("");
    setCardNumbers(["", "", "", ""]);
    setMonth("");
    setYear("");
    setSelectedDate(null);
    setPaymentType(null);
    setCardPassword("");
    setBirth("");
  };

  const onlyNumber = (value) => {
    return value.replace(/[^0-9]/g, "");
  };

  const handleInputChange = (index, value) => {
    const numericValue = onlyNumber(value);

    if (numericValue.length <= 4) {
      const newCardNumbers = [...cardNumbers];
      newCardNumbers[index] = numericValue;
      setCardNumbers(newCardNumbers);

      if (numericValue.length === 4 && index < 3) {
        inputRefs[index + 1].current?.focus();
      }
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && cardNumbers[index] === "" && index > 0) {
      inputRefs[index - 1].current?.focus();
    }

    if (e.key === "Enter" && index < 3) {
      inputRefs[index + 1].current?.focus();
    }
  };

  const handleMonthChange = (value) => {
    const numericValue = onlyNumber(value);
    const stringValue = value;

    if (numericValue.length <= 2) {
      if (
        numericValue === "" ||
        (parseInt(numericValue) >= 0 && parseInt(numericValue) <= 12)
      ) {
        setMonth(stringValue);

        if (numericValue.length === 2) {
          yearRef.current?.focus();
        }
      }
    }
  };

  const handleYearChange = (value) => {
    const numericValue = onlyNumber(value);
    const stringValue = value;

    if (numericValue.length <= 2) {
      setYear(stringValue);
    }
  };

  const handleCardPasswordChange = (value) => {
    const numericValue = onlyNumber(value);

    if (numericValue.length <= 2) {
      setCardPassword(numericValue);
    }
  };

  const handleBirthChange = (value) => {
    const numericValue = onlyNumber(value);

    if (numericValue.length <= 10) {
      setBirth(numericValue);
    }
  };

  const handleMonthKeyDown = (e) => {
    if (e.key === "Enter" || (e.key === "ArrowRight" && month.length > 0)) {
      yearRef.current?.focus();
    }
  };

  const handleYearKeyDown = (e) => {
    if (e.key === "Backspace" && year === "") {
      monthRef.current?.focus();
    }
    if (e.key === "ArrowLeft") {
      monthRef.current?.focus();
    }
  };

  const handleDateSelect = (date) => {
    setSelectedDate(date);
  };

  const handlePaymentTypeSelect = (value) => {
    setPaymentType(value);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setSelectIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    handleTotalPrice();
  }, [selected, countValue]);

  if (!isOpen) return null;

  return (
    <div className={`product-donate-modal modal-wrap`}>
      <div
        className={`overlay`}
        onClick={() => {
          reset();
          onClose();
        }}
      >
        <div className={`modal`} onClick={(e) => e.stopPropagation()}>
          <div>
            <button
              className={`backBtn`}
              onClick={() => {
                reset();
                onBack();
              }}
            >
              <img src={arrowBackSvg} alt="" />
            </button>

            <button
              className={`closeBtn`}
              onClick={() => {
                reset();
                onClose();
              }}
            >
              <img src={closeSvg} alt="" />
            </button>
          </div>
          <ul className={`content`}>
            <li className={`business`}>
              {paymentSelect === "subscription" ? "정기 결제" : "일반 결제"}
            </li>

            <li className={`label donor-name`}>기부자 명</li>
            <li className={`input donor-name-input`}>
              <input
                type="text"
                value={name}
                onChange={nameChange}
                placeholder="성함을 입력해주세요."
              />
            </li>

            <li className={`label phone-number`}>휴대폰 번호</li>
            <li className={`input phone-number-input`}>
              <input
                type="text"
                value={phoneNumber}
                placeholder="휴대폰 번호를 입력하세요"
                readOnly={true}
              />
            </li>

            <li
              className={`label payment-type ${
                paymentSelect === "subscription" && `none`
              }`}
            >
              결제수단
            </li>
            <li
              className={`input payment-type-buttons ${
                paymentSelect === "subscription" && `none`
              }`}
            >
              <button
                onClick={() => handlePaymentTypeSelect("card")}
                className={`${paymentType === "card" ? "on" : ""}`}
              >
                신용카드
              </button>
              <button
                onClick={() => handlePaymentTypeSelect("bank")}
                className={`${paymentType === "bank" ? "on" : ""}`}
              >
                계좌이체
              </button>
            </li>

            <li
              className={`label card-number ${
                paymentSelect === "single" && `none`
              }`}
            >
              신용카드
            </li>
            <li
              className={`input card-number-inputs ${
                paymentSelect === "single" && `none`
              }`}
            >
              {cardNumbers.map((number, index) => (
                <>
                  <input
                    ref={inputRefs[index]}
                    type="text"
                    value={number}
                    onChange={(e) => handleInputChange(index, e.target.value)}
                    onKeyDown={(e) => handleKeyDown(index, e)}
                    maxLength="4"
                  />
                  {index < 3 && <span>-</span>}
                </>
              ))}
            </li>

            <li
              className={`card-expiry ${paymentSelect === "single" && `none`}`}
            >
              <input
                ref={monthRef}
                type="text"
                value={month}
                onChange={(e) => handleMonthChange(e.target.value)}
                onKeyDown={handleMonthKeyDown}
                placeholder="MM"
                maxLength="2"
              />
              <span>/</span>
              <input
                ref={yearRef}
                type="text"
                value={year}
                onChange={(e) => handleYearChange(e.target.value)}
                onKeyDown={handleYearKeyDown}
                placeholder="YY"
                maxLength="2"
              />
            </li>

            <li
              className={`label card-password ${
                paymentSelect === "single" && `none`
              }`}
            >
              비밀번호
            </li>
            <li
              className={`input card-password-input ${
                paymentSelect === "single" && `none`
              }`}
            >
              <input
                type="password"
                placeholder="비밀번호 (앞 2자리)"
                maxLength="2"
                onChange={(e) => handleCardPasswordChange(e.target.value)}
                value={cardPassword}
              />
            </li>

            <li
              className={`label birth ${paymentSelect === "single" && `none`}`}
            >
              카드 소유주 생년월일
            </li>
            <li
              className={`input birth-input ${
                paymentSelect === "single" && `none`
              }`}
            >
              <input
                type="text"
                placeholder="생년월일 6자리 입력(YYMMDD)"
                maxLength="10"
                onChange={(e) => handleBirthChange(e.target.value)}
                value={birth}
              />
            </li>

            <li
              className={`label payment-date ${
                paymentSelect === "single" && `none`
              }`}
            >
              결제일
            </li>
            <li
              className={`input payment-date-buttons ${
                paymentSelect === "single" && `none`
              }`}
            >
              <button
                onClick={() => handleDateSelect("10")}
                className={`${selectedDate === "10" ? "on" : ""}`}
              >
                10일
              </button>
              <button
                onClick={() => handleDateSelect("20")}
                className={`${selectedDate === "20" ? "on" : ""}`}
              >
                20일
              </button>
            </li>

            <li className={`label amount`}>상품 선택</li>
            <li className={`input donation-amount`}>
              <div className={`donation-dropdown`} ref={dropdownRef}>
                <div className={`dropdown-box`}>
                  <div
                    className={`select-box ${selectIsOpen ? "open" : ""}`}
                    onClick={() => setSelectIsOpen(!selectIsOpen)}
                  >
                    <span className={`selected-text`}>
                      {selected || "기부할 금액을 선택해주세요."}
                    </span>
                    <span className={`arrow`}>
                      {selectIsOpen ? (
                        <img src={arrowUpSvg} alt="" />
                      ) : (
                        <img src={arrowDownSvg} alt="" />
                      )}
                    </span>
                  </div>

                  <div className={`count`}>
                    <input
                      type="text"
                      value={countValue}
                      onChange={(e) => {
                        const input = e.target.value.replace(/[^\d]/g, "");
                        setCountValue(input);
                      }}
                      className={`count-input`}
                    />
                  </div>
                </div>

                {selectIsOpen && (
                  <div className={`dropdown-list`}>
                    {options.map((option) => (
                      <div
                        key={option}
                        className={`dropdown-item ${
                          selected === option ? "selected" : ""
                        }`}
                        onClick={() => handleSelect(option)}
                      >
                        {option}
                      </div>
                    ))}
                  </div>
                )}

                <span className={`won`}>
                  <input
                    type="text"
                    value={
                      totalPrice
                        ? Number(totalPrice).toLocaleString("ko-KR")
                        : ""
                    }
                    placeholder="금액 :"
                    readOnly={true}
                    style={{ marginTop: "8px" }}
                  />
                </span>
              </div>
            </li>

            <li className={`submit`}>
              <button
                onClick={async () => {
                  if (validate()) {
                    onSuccess &&
                      onSuccess(name, totalPrice, paymentType, {
                        payment_day: parseInt(selectedDate),
                        cardNumb: cardNumbers.join(""),
                        expiryDate: `${year}${month}`,
                        password2: cardPassword,
                        userInfo: birth,
                        buyer_name: name,
                        payment_content:
                          paymentType === "bank" ? "후원" : "정기후원",
                      });
                    reset();
                  }
                }}
              >
                결제
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default ProductDonateModal;
